import axios from 'axios'
import {Message} from 'element-ui'
import router from '../router'
import {removeLocalStorage} from '../utils/storage'

axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/x-www=form-urlencoded'
axios.interceptors.response.use((response) => {
  return response
  // const data = response.data
  // const err = new Error()
  // err.data = data
  // err.response = response
  // throw err
}, (err) => {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误'
        break

      case 401:
        err.message = '登录信息失效，请重新登录'
        // removeLocalStorage('buyCart')
        removeLocalStorage('UserUUID')
        removeLocalStorage('UserUUID')
        removeLocalStorage('Token')
        removeLocalStorage('UserInfo')
        removeLocalStorage('LoginUUID')
        router.replace({
          path: '/login'
        })
        break

      case 403:
        err.message = '拒绝访问'
        break

      case 404:
        err.message = `请求地址出错: ${err.response.config.url}`
        break

      case 408:
        err.message = '请求超时'
        break

      case 500:
        err.message = '服务器内部错误'
        break

      case 501:
        err.message = '服务未实现'
        break

      case 502:
        err.message = '网关错误'
        break

      case 503:
        err.message = '服务不可用'
        break

      case 504:
        err.message = '网关超时'
        break

      case 505:
        err.message = 'HTTP版本不受支持'
        break

      default:
    }
  }
  Message.error({message: err.message})
  return Promise.reject(err)
})

export default {
  get (url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('kaibuy_store_Token') || null
      axios.get(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  post (url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('kaibuy_store_Token') || null
      axios.post(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  file (url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('kaibuy_store_Token') || null
      axios.post(url, params, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  put (url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('kaibuy_store_Token') || null
      axios.put(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  delete (url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('kaibuy_store_Token') || null
      axios.delete(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  _get (url) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('kaibuy_store_Token') || null
      axios.get(url).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  _post (url) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('kaibuy_store_Token') || null
      axios.post(url).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  _delete (url) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('kaibuy_store_Token') || null
      axios.delete(url).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/public.js